module.exports = __webpack_public_path__ + "static/media/Item 19.e6f9d9bf.jpg";